import fetch from '@/utils/axios';
import {api_url} from '@/global';

const gateway = `${api_url}/organization`;

// 查看是否是组织创建者
export const checkIsCreater = companyId => fetch({
  url: `${gateway}/company/validate/${companyId}`
});

// 获取组织架构所有部门
export const getAllDept = companyId => fetch({
  url: `${gateway}/rpc/company/dept/all/${companyId}`
});

// 获取用户所属部门
export const getUserDept = (companyId, userId) => fetch({
  url: `${gateway}/company/manager/deptAndManager/${companyId}/${userId}`
});

// 获取组织基本信息
export const getCompanyInfo = (companyId) => fetch({
  url: `${gateway}/company/${companyId}`
});

// 更新组织信息
export const putCompanyInfo = (data) => fetch({
  data,
  method: 'put',
  url: `${gateway}/company/admin`
});

// 获取用户组织列表
export const getUserCompanyList = (userId) => fetch({
  url: `${gateway}/company/user/${userId}`
});

// 获取组织全部人员
export const getCompanyUserList = (companyId, type = 0) => fetch({
  url: `${gateway}/personnel/schedule/${companyId}/${type}/members`
});

// 申请加入组织
export const applyJoinCompany = (data) => fetch({
  data,
  method: 'put',
  url: `${gateway}/personnel/v2/schedule/apply`
});

// 根据名称搜索组织
export const searchCompany = (keyword) => fetch({
  url: `${gateway}/company?keyword=${keyword}`
});

// 创建组织
export const createCompany = (data) => fetch({
  data,
  method: 'post',
  url: `${gateway}/company`
});

// 解散组织
export const deleteCompany = (companyId, mobile, code) => fetch({
  method: 'delete',
  url: `${gateway}/company/${companyId}/${mobile}/${code}`
});

// 组织移除人员
export const deleteMember = (data) => fetch({
  data,
  method: 'delete',
  url: `${gateway}/personnel/v2/admin/schedule/leave/`
});

// 更换组织创建者
export const changeCompanyAdmin = (data) => fetch({
  data,
  method: 'put',
  url: `${gateway}/company/ams/attorn`
});

// 获取名称logo信息
export const getInviteInfo = (companyId, userId) => fetch({
  url: `${gateway}/employee/imglogo/${companyId}/${userId}`
});

// 检查手机号码是否注册是否属于某组织
export const checkPhone = (phone, cId) => fetch({
  url: `${gateway}/employee/phone/${phone}/${cId}`
});

export const getPanCompanyUserList = (companyId,type) =>fetch({
  url: `${gateway}/personnel/schedule/${companyId}/${type}/members`
})
